import React, { useState, useEffect, useContext, useMemo } from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../../layout"
import SEO from "../../seo"

import { Cover } from "../../anti/cover/cover"
import { Card } from "../../anti/card/card"
import { Container, Section } from "../../anti/grid/grid"
import { Select } from "../../anti/form/form"
import { Breadcrumb } from "../../anti/breadcrumb/breadcrumb"

import Shape from "../../../assets/img/common/shape.png"
import { LangContext } from "../../../context/LangContext"
import "./style.scss"

import "@glidejs/glide/dist/css/glide.core.min.css"
import "@glidejs/glide/dist/css/glide.theme.min.css"
import { BackgroundImage, ImgRatio } from "../../anti/utils/utils"
import { Button } from "../../anti/buttons/buttons"
import Modal from "react-modal"
import { LeadForm } from "../../anti/lead-form/lead-form"

const CLUSTER_OPTIONS = [
  {
    label: "Cluster",
    value: "cluster",
  },
  {
    label: "Apartement",
    value: "apartment",
  },
  {
    label: "Commercial",
    value: "commercial",
  },
]

const CompareUnit = ({ location, pageContext }) => {
  const { lang, setLang } = useContext(LangContext)

  const data = useStaticQuery(graphql`
    query {
      wordPress {
        residential: propertyTypes(where: { slug: "residential" }) {
          nodes {
            name
            description
            children {
              nodes {
                name
                slug
                projects {
                  nodes {
                    title
                    slug
                    featuredImage {
                      sourceUrl
                    }
                    projectCustomfields {
                      clusterCode
                      leadSourceName
                      projectsCode
                    }
                    blocks {
                      ... on WordPress_AcfIconlistBlock {
                        acfBlockIconList {
                          list {
                            title
                            description
                          }
                        }
                      }
                      ... on WordPress_AcfMapWithFeaturesBlock {
                        dynamicContent
                        originalContent
                        MapWFeatures {
                          featuresBottom {
                            name
                            text
                          }
                          featuresTop {
                            name
                            text
                          }
                        }
                      }
                    }
                    propertyTypes {
                      nodes {
                        name
                        slug
                      }
                    }
                  }
                }
              }
            }
          }
        }
        commercial: propertyTypes(where: { slug: "commercial" }) {
          nodes {
            name
            description
            children {
              nodes {
                name
                slug
                projects {
                  nodes {
                    title
                    slug
                    featuredImage {
                      sourceUrl
                    }
                    projectCustomfields {
                      clusterCode
                      leadSourceName
                      projectsCode
                    }
                    blocks {
                      ... on WordPress_AcfIconlistBlock {
                        acfBlockIconList {
                          list {
                            title
                            description
                          }
                        }
                      }
                      ... on WordPress_AcfMapWithFeaturesBlock {
                        dynamicContent
                        originalContent
                        MapWFeatures {
                          featuresBottom {
                            name
                            text
                          }
                          featuresTop {
                            name
                            text
                          }
                        }
                      }
                    }
                    propertyTypes {
                      nodes {
                        name
                        slug
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const [modal, setModal] = useState({ data: null, show: false })

  //   const dataCluster =
  //     data?.wordpress?.residential?.nodes?.[0]?.children?.nodes ?? []
  const dataCluster = (
    data?.wordPress?.residential?.nodes?.[0]?.children?.nodes || []
  ).find(item => item.slug === "cluster").projects.nodes
  const dataApartment = (
    data?.wordPress?.residential?.nodes?.[0]?.children?.nodes || []
  ).find(item => item.slug === "apartment")?.projects?.nodes
  const dataCommersial = (
    data?.wordPress?.commercial?.nodes?.[0].children.nodes || []
  ).flatMap(item => item.projects?.nodes)

  const allData = {
    cluster: dataCluster,
    apartment: dataApartment,
    commercial: dataCommersial,
  }

  const [filter, setFilter] = useState({
    1: {},
    2: {},
    3: {},
  })
  const [selectedUnit, setSelectedUnit] = useState({
    1: {},
    2: {},
    3: {},
  })

  useEffect(() => {
    const url = new URL(window.location.href)
    const searchParams = new URLSearchParams(url.search)
    const slug = searchParams.get("slug")
    const propertyTypes = searchParams.get("propertyTypes")

    if (slug && propertyTypes) {
      const selectedData = allData?.[propertyTypes]?.find(
        item => item.slug === slug
      )

      console.log(selectedData, "selecteddd")

      const facilities = selectedData?.blocks
        .find(item => item.__typename === "WordPress_AcfIconlistBlock")
        ?.acfBlockIconList?.list?.map(it => it.title)

      const areaSurrounding = selectedData?.blocks.find(
        item => item.__typename === "WordPress_AcfMapWithFeaturesBlock"
      )?.MapWFeatures?.featuresTop

      const image = selectedData?.featuredImage?.sourceUrl

      setSelectedUnit(prev => ({
        ...prev,
        [1]: {
          cluster: selectedData?.propertyTypes?.nodes?.[0]?.name,
          unitType: selectedData?.title,
          areaSurrounding,
          facilities,
          image,
        },
      }))
    }
  }, [data])

  const FilterComponent = ({ index, lang, unitOrder }) => {
    const clusterValue = filter[unitOrder].cluster
    const unitValue = filter[unitOrder].unit
    const handleChangeCluster = e => {
      setFilter(prev => ({
        ...prev,
        [unitOrder]: {
          cluster: e,
        },
      }))
    }
    const handleChangeUnit = e => {
      const selectedData = allData?.[clusterValue.value].find(
        item => item.slug === e.value
      )

      const facilities = selectedData?.blocks
        .find(item => item.__typename === "WordPress_AcfIconlistBlock")
        ?.acfBlockIconList?.list?.map(it => it.title)

      const areaSurrounding = selectedData?.blocks.find(
        item => item.__typename === "WordPress_AcfMapWithFeaturesBlock"
      )?.MapWFeatures?.featuresTop

      const image = selectedData?.featuredImage?.sourceUrl

      setSelectedUnit(prev => ({
        ...prev,
        [unitOrder]: {
          ...selectedData,
          cluster: clusterValue.label,
          unitType: e.label,
          areaSurrounding,
          facilities,
          image,
        },
      }))

      setFilter(prev => ({
        ...prev,
        [unitOrder]: {
          ...prev[unitOrder],
          unit: e,
        },
      }))
    }

    const unitOptions = clusterValue
      ? allData?.[clusterValue.value]?.map(item => ({
          label: item.title,
          value: item.slug,
        }))
      : []
    return (
      <>
        {index == 1 && (
          <div
            className="form-group mb-md-0"
            style={{
              position: "relative",
              zIndex: 99,
            }}
          >
            <Select
              defaultValue
              callback={handleChangeCluster}
              value={clusterValue}
              placeholder={lang == "EN" ? "Select Cluster" : "Pilih Cluster"}
              options={CLUSTER_OPTIONS}
              name="category"
              className="select-w-icon"
            />
          </div>
        )}
        {index == 2 && (
          <div
            className="form-group mb-md-0"
            style={{
              position: "relative",
              zIndex: 9,
            }}
          >
            <Select
              defaultValue
              value={unitValue}
              callback={handleChangeUnit}
              placeholder={lang == "EN" ? "Select Units" : "Pilih Units"}
              options={unitOptions}
              isDisabled={!filter[unitOrder].cluster}
              name="category"
              className="select-w-icon"
            />
          </div>
        )}
      </>
    )
  }

  const dataTable = [
    {
      key: "",
      unit1: selectedUnit[1].image,
      unit2: selectedUnit[2].image,
      unit3: selectedUnit[3].image,
    },
    {
      key: "Cluster",
      unit1: selectedUnit[1].cluster,
      unit2: selectedUnit[2].cluster,
      unit3: selectedUnit[3].cluster,
    },
    {
      key: "Unit Type",
      unit1: selectedUnit[1].unitType,
      unit2: selectedUnit[2].unitType,
      unit3: selectedUnit[3].unitType,
    },
    {
      key: "Facilities",
      unit1: selectedUnit[1].facilities,
      unit2: selectedUnit[2].facilities,
      unit3: selectedUnit[3].facilities,
      // unit1: "hoho",
    },
    {
      key: "Area Surrounding",
      unit1: selectedUnit[1].areaSurrounding,
      unit2: selectedUnit[2].areaSurrounding,
      unit3: selectedUnit[3].areaSurrounding,
      // unit1: "kaka",
    },
    {
      key: "",
      // unit1: "kaka",
    },
  ]

  const RenderColumn = ({ item, index, unitOrder }) => {
    if (index === 0) {
      return (
        <div
          className="w-full d-flex justify-content-center"
          style={{ position: "relative" }}
        >
          <div
            style={{
              backgroundColor: "red",
              width: "100%",
              height: 150,
              background: `url("${item}") center center / cover no-repeat`,
            }}
          >
            <ImgRatio />
          </div>
          {selectedUnit[unitOrder].cluster && (
            <div
              className="popup-close w-bg pointer"
              style={{
                position: "absolute",
                right: 8,
                top: 8,
                backgroundColor: "lightsteelblue",
                borderRadius: 10,
                width: 20,
                height: 20,
                textAlign: "center",
              }}
              onClick={() => {
                setSelectedUnit(prev => ({
                  ...prev,
                  [unitOrder]: {},
                }))
                setFilter(prev => ({
                  ...prev,
                  [unitOrder]: {},
                }))
              }}
            >
              <i className="fal fa-times"></i>
            </div>
          )}

          {/* <Button>wkwk</Button> */}
        </div>
      )
    }
    if (index < 3) {
      return (
        <div>
          {item ? (
            item
          ) : (
            <FilterComponent
              key={index}
              index={index}
              unitOrder={unitOrder}
              lang={lang}
            />
          )}
        </div>
      )
    }
    if (index === 3) {
      return (
        <div className="px-3 py-2">
          {item?.map((it, idx) => {
            return (
              <div key={idx} className="row">
                <p>{idx + 1}.</p>
                <div className="ml-2">
                  <p>{it}</p>
                </div>
              </div>
            )
          })}
        </div>
      )
    }
    if (index === 4) {
      return (
        <div className="px-3 py-2">
          {item?.map((it, idx) => {
            return (
              <div key={idx} className="row">
                <p>{idx + 1}.</p>
                <div className="ml-2">
                  <p>{it.name}</p>
                  <p>{it.text}</p>
                </div>
              </div>
            )
          })}
        </div>
      )
    }
    if (
      index === 5 &&
      selectedUnit?.[unitOrder].cluster &&
      selectedUnit?.[unitOrder].unitType
    ) {
      return (
        <Button
          variant="secondary btn-p-all"
          onClick={() => {
            setModal({
              show: true,
              data: selectedUnit?.[unitOrder],
            })
          }}
        >
          {/* {lang === "EN" ? "Calculate here" : "Hitung disini"} */}
          {"Contact Us"}
          <i className="fas fa-arrow-right ml-3"></i>
        </Button>
      )
    }
    return null
  }

  const openModal = data => {
    setModal({ data: data, show: true })
  }

  const closeModal = () => {
    setModal({ show: false })
  }

  return (
    <Layout disableEffect>
      <Section className="bg-light">
        <Container className="mw-lg text-md-center">
          <h2 className="h2">Unit Comparing</h2>
        </Container>
      </Section>

      <Section className="py-0 bg-white mt-5">
        <Container className="p-0 text-md-center">
          <div style={{ width: "100%", textAlign: "left" }}>
            <p className="font-weight-bold" style={{ fontSize: 20 }}>
              Comparing
            </p>
          </div>
          <div className="table-responsive">
            <table className="table">
              <tbody className="t-body">
                {dataTable.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="sticky-col">{item.key}</td>
                      <td>
                        <RenderColumn
                          item={item.unit1}
                          index={index}
                          unitOrder={1}
                        />
                      </td>
                      <td>
                        <RenderColumn
                          item={item.unit2}
                          index={index}
                          unitOrder={2}
                        />
                      </td>
                      <td>
                        <RenderColumn
                          item={item.unit3}
                          index={index}
                          unitOrder={3}
                        />
                      </td>
                    </tr>
                  )
                })}
                <tr style={{ height: 300 }}></tr>
              </tbody>
            </table>
          </div>
        </Container>
      </Section>
      <Modal
        // overlayClassName="d-md-fixed d-none"
        isOpen={modal.show}
        onRequestClose={closeModal}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
          },
        }}
        contentLabel="failcity details"
        className="d-md-block d-none"
      >
        <div className="modal-popup-home bg-light modal-body">
          <div className="popup-close">
            <i className="fal fa-times" onClick={closeModal}></i>
          </div>
          <Container>
            <LeadForm
              name={modal.data?.unitType}
              clusterCode={modal.data?.projectCustomfields?.clusterCode}
              leadSourceName={modal.data?.projectCustomfields?.leadSourceName}
              projectsCode={modal.data?.projectCustomfields?.projectsCode}
            />
          </Container>
        </div>
      </Modal>
    </Layout>
  )
}

export default CompareUnit
